import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import NotificationsTable from './table';

const AccordionNotificationsComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-practice-content"
        id="accordion-practice-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Notifiche</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <NotificationsTable />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionNotificationsComponent.displayName = 'Accordion Notifications';

const AccordionNotifications = memo(AccordionNotificationsComponent);

export default AccordionNotifications;
